<template>
  <vs-popup class="special-cleaning-popup" title="특별 클리닝 신청서" :active.sync="popupActive">
    <div class="text-right">
      <vs-button class="mr-2" @click="save">저장</vs-button>
      <vs-button @click="print">프린트</vs-button>
    </div>
    <div class="special-cleaning-page">
      <span class="text-sm">&nbsp;</span>
      <table class="w-full">
        <colgroup>
          <col width="21%" />
          <col width="29%" />
          <col width="19.5%" />
          <col width="30.5%" />
        </colgroup>
        <tbody>
          <tr>
            <td colspan="4" class="text-2xl font-bold">특별클리닝(펠릿 교체·충진) 신청서</td>
          </tr>
          <tr>
            <td colspan="4" class="text-left pt-4 pb-4">
              <span class="text-lg ml-2">◯ 신청대상</span>
              <div class="w-full px-3 mt-1 mb-2">
                <table class="w-full" style="table-layout: fixed;">
                  <colgroup>
                    <col width="15%"/>
                    <col width="35%"/>
                    <col width="15%"/>
                    <col width="35%"/>
                  </colgroup>
                  <tr>
                    <td>차량번호</td>
                    <td>{{ audit.vehicleNumber }} / {{ audit.currentVehicleNumber }}</td>
                    <td>소유자(법인)</td>
                    <td>{{ audit.ownerName }}</td>
                  </tr>
                  <tr>
                    <td>차명/차종</td>
                    <td>{{ audit.vehicleName }} / {{ audit.vehicleType }}</td>
                    <td>용도/주행거리</td>
                    <td><span style="width:45%;display:inline-block;text-align:right;">{{ audit.usage }}</span> / <span style="width:30%;display:inline-block;text-align:left;">{{ audit.nextMileage }}</span>km</td>
                  </tr>
                  <tr>
                    <td>장치 구변일</td>
                    <td>{{ audit.structureChangeDate }}</td>
                    <td>차대번호</td>
                    <td>{{ audit.vehicleId }}</td>
                  </tr>
                  <tr>
                    <td>소유자 주소</td>
                    <td style="word-wrap: break-word;">{{ audit.address }}</td>
                    <td>사용본거지</td>
                    <td style="word-wrap: break-word;">{{ audit.address }}</td>
                  </tr>
                  <tr>
                    <td>연락처</td>
                    <td class="text-left pl-1" colspan="3">{{ audit.lastPhone }}</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td class="text-left pt-4 pb-4" colspan="4">
              <span class="text-lg ml-2">◯ 그간 클리닝(펠릿 교체·충진) 실시 현황</span>
              <div class="w-full px-3 mt-2 mb-2">
                <table class="w-full">
                  <colgroup>
                    <col width="7%"/>
                    <col width="13%"/>
                    <col width="30%"/>
                    <col width="20%"/>
                    <col width="30^"/>
                  </colgroup>
                  <tr>
                    <td rowspan="2">1차</td>
                    <td>일시</td>
                    <td>{{ audit.firstCleaningDate }}</td>
                    <td>주행거리</td>
                    <td>{{ audit.prevMileage }} Km</td>
                  </tr>
                  <tr>
                    <td>전/후 필터<br/>일련번호</td>
                    <td>{{ audit.prevSerial1 }} / {{ audit.prevSerial2 }}</td>
                    <td>전/후 배압</td>
                    <td>{{ audit.prevBackPressure1 }} / {{ audit.prevBackPressure2 }}</td>
                  </tr>
                  <tr>
                    <td rowspan="2">2차</td>
                    <td>일시</td>
                    <td>{{ audit.secondCleaningDate }}</td>
                    <td>주행거리</td>
                    <td>{{ audit.mileage }} Km</td>
                  </tr>
                  <tr>
                    <td>전/후 필터<br/>일련번호</td>
                    <td>{{ audit.serial1 }} / {{ audit.serial2 }}</td>
                    <td>전/후 배압</td>
                    <td>{{ audit.backPressure1 }} / {{ audit.backPressure2 }}</td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4" class="text-left pt-2 pb-16">
              <span class="text-lg ml-2">◯ 요청사유</span>
              <p class="ml-2 mt-2 mb-2">※ 특별 클리닝(펠릿 교체·충진) 사유를 구체적으로 기술하시오.</p>

              <p :key="index" class="mt-2 ml-4 relative" v-for="(reason, index) in $root.requestReasons">
                <feather-icon :icon="audit.requestReason === reason ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important;" svgClasses="h-6 w-5"/>
                <label class="ml-6" @click="checkSpecialCleaningReason('backPressure')">{{ reason}}</label>
              </p>
              <p class="mt-2 ml-4 relative">
                <feather-icon icon="SquareIcon" color="primary" style="position: absolute !important;" svgClasses="h-6 w-5"/>
                <label class="ml-6">기타 사유</label>
              </p>
            </td>
          </tr>
          <tr>
            <td class="text-left" colspan="4">
              <p class="pl-2 mt-4 mb-6">위 사유로 특별 클리닝 (펠릿 교체·충진)을 신청합니다.</p>
              <p class="w-full text-center mt-24">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ audit.thirdCleaningDate ? audit.thirdCleaningDate.split("-")[0] : "&nbsp;&nbsp;&nbsp;&nbsp;" }}&nbsp;&nbsp;년&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ audit.thirdCleaningDate ? audit.thirdCleaningDate.split("-")[1] : "&nbsp;&nbsp;" }}&nbsp;&nbsp;월&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ audit.thirdCleaningDate ? audit.thirdCleaningDate.split("-")[2] : "&nbsp;&nbsp;" }}&nbsp;&nbsp;일</p>
              <table class="w-full no-border mt-8 mb-4">
                <colgroup>
                  <col width="50%" />
                  <col width="30%" />
                  <col width="20%" />
                </colgroup>
                <tbody>
                  <tr>
                    <td class="text-right pr-2 text-lg">차량소유자</td>
                    <td class="text-left">{{ audit.ownerName }}</td>
                    <td class="text-left" style="position: relative;">(인)<img :src="audit.signature" style="position: absolute; top: -16px; right: 90px; z-index: 0; width: 64px;"></td>
                  </tr>
                  <tr>
                    <td class="h-4"></td>
                  </tr>
                  <tr>
                    <td class="text-right pr-2 text-lg">장치제작자</td>
                    <td class="text-left">HK-MNS</td>
                    <td class="text-left" style="position: relative"><img src="@/assets/images/hk-mns.png" class="img-hk-mns" style="position: absolute; top: -26px; z-index: 0; width: 90px;"></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </vs-popup>
</template>

<script>
export default {
  data () {
    return {
      popupActive: false,
      audit: {}
    }
  },
  methods: {
    open (audit) {
      this.popupActive = true
      this.audit = audit
    },
    checkSpecialCleaningReason (reason) {
      this.audit.specialCleaningReason = reason
      this.audit = {
        ...this.audit
      }
    },
    save () {
      this.$vs.loading()
      this.$db.collection('installations').doc(this.audit.id).update(this.audit).then(() => {
        this.$vs.loading.close()
        alert('저장되었습니다.')
      })
    },
    print () {
      const css = '@page { size: portrait; margin: 20px 40px; }'
      const head = document.head || document.getElementsByTagName('head')[0]
      const style = document.createElement('style')

      style.type = 'text/css'
      style.media = 'print'

      if (style.styleSheet) {
        style.styleSheet.cssText = css
      } else {
        style.appendChild(document.createTextNode(css))
      }

      head.appendChild(style)

      window.print()
    }
  }
}
</script>

<style lang="scss">

@media screen {
  .special-cleaning-popup .vs-popup {
    width: 730px !important;
  }
  .img-seocheon {
    right: 98px;
  }
  .img-hk-mns {
    right: 80px;
  }
}

@media print {
  #app {
    display: none;
  }
  .special-cleaning-page {
      width: 100%;
      background-color: white;
      position: absolute;
      top: 0;
      left: 0;
      margin: 0;
  }
  .img-seocheon {
    right: 88px;
  }
  .img-hk-mns {
    right: 70px;
  }
}

.special-cleaning-popup table {
  // border: 1px solid #c8c8c8;
  border-collapse: collapse;
}

.special-cleaning-popup table td {
  text-align: center;
  padding: 4px 2px;
  border: 1px solid #000;
}

.special-cleaning-popup table th {
  background-color: #efefef;
}

.special-cleaning-popup table th.bg-white {
  border: none;
}

.detail-category-popup .vs-con-input-label {
  width: 100%;
}

.special-cleaning-popup table .no-border td {
  border: none;
}

</style>
